import { render, staticRenderFns } from "./BreakoutRoomsParticipantsEditor.vue?vue&type=template&id=64db1eda&scoped=true"
import script from "./BreakoutRoomsParticipantsEditor.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsParticipantsEditor.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsParticipantsEditor.vue?vue&type=style&index=0&id=64db1eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db1eda",
  null
  
)

export default component.exports